/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://7wbg7rb5efesha7qhkalsnzzmy.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-dtq6m4xmx5ceboahnu7tak4rti",
    "aws_cognito_identity_pool_id": "us-east-1:16ed0685-28de-4dee-9595-35dfc8783d9a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_R4Dll2fOX",
    "aws_user_pools_web_client_id": "4mp0ifj9u7vs06c4rtlfbcvq9a",
    "oauth": {
        "domain": "recruitmentdashboard3a67d641-3a67d641-bfaprod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://dev.openpath.ai/,https://preview.openpath.ai/,https://prod.openpath.ai/,https://k2.openpath.ai/,https://demo.openpath.ai/,https://wcr-dev.openpath.ai/,https://wcr.openpath.ai/,https://qct-dev.openpath.ai/,https://qct.openpath.ai/,https://bfa.openpath.ai/,https://rm.openpath.ai/,https://publisher.com:3000/,https://dev.openpath.ai/landing.html,https://preview.openpath.ai/landing.html,https://prod.openpath.ai/landing.html,https://k2.openpath.ai/landing.html,https://demo.openpath.ai/landing.html,https://wcr-dev.openpath.ai/landing.html,https://wcr.openpath.ai/landing.html,https://qct-dev.openpath.ai/landing.html,https://qct.openpath.ai/landing.html,https://bfa.openpath.ai/landing.html,https://rm.openpath.ai/landing.html,https://publisher.com:3000/landing.html",
        "redirectSignOut": "https://dev.openpath.ai/,https://preview.openpath.ai/,https://prod.openpath.ai/,https://k2.openpath.ai/,https://demo.openpath.ai/,https://wcr-dev.openpath.ai/,https://wcr.openpath.ai/,https://qct-dev.openpath.ai/,https://qct.openpath.ai/,https://bfa.openpath.ai/,https://rm.openpath.ai/,https://publisher.com:3000/,https://dev.openpath.ai/landing.html,https://preview.openpath.ai/landing.html,https://prod.openpath.ai/landing.html,https://k2.openpath.ai/landing.html,https://demo.openpath.ai/landing.html,https://wcr-dev.openpath.ai/landing.html,https://wcr.openpath.ai/landing.html,https://qct-dev.openpath.ai/landing.html,https://qct.openpath.ai/landing.html,https://bfa.openpath.ai/landing.html,https://rm.openpath.ai/landing.html,https://publisher.com:3000/landing.html",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
